<template>
<div>
  <DataTable
  :title=title
  :column_names=column_names
  :columns=column_definitions
  :total_data_from_parent=total_data
  :resource_url_from_parent=resource_url
  :form_name_from_parent=form_name
  :modal_name_from_parent=modal_name
  :resource_filter_from_parent=resource_filter
  :export_file_name_from_parent=export_file_name
  />
</div>

</template>

<script>

import DataTable from "./BaseTable.vue"
import moment from "moment";
// import $ from "jquery";

export default {
  components: {
    DataTable,
  },
    data: function () {
    return {
      title: "Danh Sách Khách Hàng Xuất Hóa Đơn",
      column_names: [
        "Tên Công Ty", 
        "Địa Chỉ", 
        "Mã Số Thuế", 
        "Ghi Chú", 
        ""],
      column_definitions: [
        { data: "name" },
        { data: "address" },
        { data: "tax_code" },
        { data: "remark" },
        {
          data: null,
          width: 100,
          defaultContent:
            '<button type="button"  action="edit"  class="btn btn-warning flat ">Sửa</button>\
            <button type="button"  action="delete" class="btn btn-danger flat ">Xóa</button>',
        },
      ],
      total_data: [
      ],
      resource_url: process.env.VUE_APP_API_ENDPOINT + "/api/v1/invoice-customers",
      resource_filter: {},
      form_name: "InvoiceCustomerForm",
      modal_name: "modal-invoice-customer-form",
      export_file_name: "danh_sach_khach_hang_hoa_don_" + moment().format("DD_MM_YYYY"),
    }
  }
}
</script>
